<template><SimpleModuleDashboard :module-id="Modules.INFORME_AUDITORIA" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'crudReport', reference: 'crudReport', route: 'ReportsAuditStaffCrudReport', tone: 'primary' },
] }) }
</script>
